import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import {
  KeyboardArrowLeft,
} from '@material-ui/icons';
import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import {
  RouteComponentProps, withRouter,
} from 'react-router';
import * as Yup from 'yup';
import {
  FormField,
} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import Spinner from '../../components/Spinner';
import {
  countriesIsoCodes,
} from '../../constants/countries';
import {
  getDropdownLanguagesList, languageCodes,
} from '../../constants/languages';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  ICountry,
} from '../../mobx-store/storeInterfaces/authInterface';
import {
  IRestaurantCategoryStore,
} from '../../mobx-store/storeInterfaces/restaurantCategoryInterface';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import classes from './addEditRestaurantCategory.module.scss';

interface IProps extends WithSnackbarProps {
  restaurantCategoryStore: IRestaurantCategoryStore;
  countryStore: CountryStore;
  match: any;
  history: any;
}

interface IState {
  formFields: FormField[];
  loadingCategory: boolean;
  loadingManagedCountries: boolean;
  processing: boolean;
  selectedLang: string;
}

@inject('restaurantCategoryStore')
@inject('countryStore')
@observer
class AddEditRestaurantCategory extends Component<IProps & RouteComponentProps, IState> {
  isNew = false;

  isEgypt = false;

  restaurantId = -1;

  categoryId = -1;

  lastHistory = -1;

  pageTitle = '';

  categoryFormTitle = '';

  categorySchema: any;

  submitButton: any;

  cancelButton: any;

  dropdownLanguages: {
    langList: {langCode: string; langValue: string} [];
    selectedLang: string;
    label: string;
    onChange(langCode: string): any;
  } | null = null;

  constructor(props: IProps & RouteComponentProps) {
    super(props);
    this.initializeComponent(props);
  }

  initializeComponent(props: IProps & RouteComponentProps, isConstructor = true) {
    this.restaurantId = props.match.params.restaurantId;
    if (props.match.params.categoryId) {
      this.isNew = false;
      this.categoryId = props.match.params.categoryId;
      this.pageTitle = translate('editRestaurantCategoryPageTitle', {
      });
    } else {
      this.isNew = true;
      this.pageTitle = translate('addRestaurantCategoryPageTitle', {
      });
    }
    this.initCategorySchema();
    this.initState(isConstructor);
    this.submitButton = this.getSubmitButton();
    this.cancelButton = this.getCancelButton();
    this.categoryFormTitle = translate('addRestaurantCategoryPageFormTitle', {
    });
    this.dropdownLanguages = this.getDropdownLanguages();
  }

  async componentWillReceiveProps(nextProps: IProps & RouteComponentProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.lastHistory = -2;
      this.initializeComponent(nextProps, false);
      this.setState({
        loadingManagedCountries: false,
      });
      this.forceUpdate();
      if (!this.isNew) {
        await this.getRestaurantCategory(languageCodes.english);
      }
    }
  }

  getDropdownLanguages = () => {
    if (this.isNew) {
      return null;
    }
    return {
      langList: getDropdownLanguagesList(),
      selectedLang: this.state.selectedLang,
      label: 'Select Languages',
      onChange: this.handelLanguageChange,
    };
  };

  handelLanguageChange = async (langCode: string) => {
    if (this.isNew) {
      this.setState({
        selectedLang: langCode,
      });
    } else {
      await this.getRestaurantCategory(langCode);
    }
  };

  initCategorySchema = () => {
    this.categorySchema = Yup.object().shape({
      title: Yup.string()
        .required('Required'),
      image: Yup.array(),
    });
  };

  initState = (isConstructor = true) => {
    const initState: IState = {
      selectedLang: this.isEgypt ? languageCodes.arabic : languageCodes.english,
      processing: false,
      loadingManagedCountries: false,
      loadingCategory: !this.isNew,
      formFields: [
        {
          name: 'title',
          label: this.isNew && this.isEgypt ? translate('addRestaurantCategoryPageFormArabicTitle', {
          }) : translate('addRestaurantCategoryPageFormEnglishTitle', {
          }),
          type: 'text',
          filedType: 'InputField',
        },
        {
          name: 'image',
          label: translate('addRestaurantCategoryPageFormImage', {
          }),
          filedType: 'GalleryField',
          isLimitToOneImage: true,
          accept: 'image/*',
          size: 200,
        },
      ],
    };
    if (isConstructor) {
      this.state = initState;
    } else {
      this.setState(initState);
    }
  };

  handelSubmit = (values: any): void => {
    const {
      countryStore,
    } = this.props;
    values.availableCountries = countryStore.managedCountries.map((country: ICountry) => country.isoCode);

    this.setState({
      processing: true,
    });
    if (this.isNew) {
      try {
        this.props.restaurantCategoryStore.createCategory(this.restaurantId, values)
          .then((response) => {
            if (this.isEgypt) {
              this.props.history.push(`${response.restaurantCategoryId}/edit`);
            } else {
              this.props.history.go(this.lastHistory);
            }
            SnackBarComponent.getInstance().openSnackbar(translate('createdMessage', {
            }), 5000, 'success');
          });
      } catch {
        this.setState({
          processing: false,
        });
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
        }), 5000, 'error');
      }
    } else {
      this.props.restaurantCategoryStore.updateCategory(values, this.categoryId, this.state.selectedLang)
        .then(() => {
          SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
          }), 5000, 'success');
          this.setState({
            processing: false,
          });
          this.props.history.go(this.lastHistory);
        }).catch((error) => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
          }), 5000, 'error');
        });
    }
  };

  handelCancel = (): void => {
    this.props.history.goBack();
  };

  getSubmitButton = () => ({
    title: (this.isNew && this.isEgypt ? 'To Next Language' : 'Save Changes'),
    onSubmit: this.handelSubmit,
  });

  getCancelButton = () => ({
    title: 'Cancel',
    onCancel: this.handelCancel,
  });

  updateStateWithCategoryData = () => {
    const formFieldsWithData = [];
    for (const field of this.state.formFields) {
      formFieldsWithData.push({
        ...field, value: this.props.restaurantCategoryStore.selectedCategory[field.name],
      });
    }
    this.setState({
      formFields: formFieldsWithData, loadingCategory: false,
    });
  };

  render() {
    return (
      <div className={classes.container}>
        <div className={classes.header}>
          <IconButton
            className={classes.backButton}
            onClick={() => this.props.history.goBack()}
            aria-label="Back"
          >
            <KeyboardArrowLeft />
          </IconButton>
        </div>
        <div className={classes.content}>
          {
            this.state.loadingCategory || this.state.loadingManagedCountries
              ? <Spinner />
              : (
                <GeneralFormComponent
                  dropdownLanguages={this.isEgypt ? this.dropdownLanguages : null}
                  formTitle={this.categoryFormTitle}
                  fields={this.state.formFields}
                  formSchema={this.categorySchema}
                  submitButton={this.submitButton}
                  cancelButton={this.cancelButton}
                  processing={this.state.processing}
                />
              )
          }
        </div>
      </div>
    );
  }

  async componentDidMount() {
    const {
      countryStore,
      restaurantCategoryStore,
    } = this.props;
    await countryStore.getUserManagedCountries();

    if (countryStore.managedCountries.some((country: ICountry) => country.isoCode === countriesIsoCodes.egypt)) {
      this.isEgypt = true;
    }
    this.initState(false);
    this.submitButton = this.getSubmitButton();

    if (!this.isNew) {
      await this.getRestaurantCategory(languageCodes.english);
    }
    this.setState({
      loadingManagedCountries: false,
    });
  }

  getRestaurantCategory = async (langCode: string) => {
    this.setState({
      loadingCategory: true,
    });
    await this.props.restaurantCategoryStore.getCategoryById(this.categoryId, langCode);
    this.updateStateWithCategoryData();
    this.dropdownLanguages!.selectedLang = langCode;
    this.setState({
      selectedLang: langCode,
    });
    this.setState({
      loadingCategory: false,
    });
  };

  openSnackbar = (message: string, duration: number, status: 'success'|'warning'|'error'|'info') => {
    this.props.enqueueSnackbar(message, {
      autoHideDuration: duration,
      variant: status,
      action: (
        <Button color="default">Dismiss</Button>
      ),
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
    });
  };
}

export default withRouter(AddEditRestaurantCategory);
